import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Storage } from '@ionic/storage';

import { SharedGlobals } from './shared-globals.service';
// import { Firebase } from '@ionic-native/firebase/ngx'; // not in use anymore

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { Router } from '@angular/router';

import { AlertController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})



export class DataService {

  public storedObjects: any;
  public curDataObjDictionary: any = {}; //store curDataObjects in dictionary for content updates
  public contentPassKey: string = 'sjdjs89428dkJes19rjkJlJOdj53'; //append at beginning if you want to block token
  
  public curPostObject: any;
  
  
  constructor(private _http: HttpClient, private storage: Storage, public sharedGlobals: SharedGlobals, private router: Router, private analytics: FirebaseAnalytics, private alertCtrl: AlertController){
        this.storedObjects = [];
       
  }


  addDateToDataUrl(dataUrl: string) {
    
    if(!dataUrl.includes('?')) {
      return dataUrl + '?v=' + (new Date).getTime();
    }
    return dataUrl + '&v=' + (new Date).getTime();
  }

 
  getPostsByType(postType: string) {

  
    if (this.sharedGlobals.curDataObj && this.sharedGlobals.curDataObj.post_type && this.sharedGlobals.curDataObj.post_type == postType && this.sharedGlobals.curDataObj.data_url) {
        
        console.log('DATA SERVICE GOOD');
        //this.setCurDataObjTempDict(this.sharedGlobals.curDataObj); // done this already when updating menu for each (rels and locked content)
        
        let dataUrl = this.sharedGlobals.curDataObj.data_url;
        dataUrl = dataUrl + '&tkn=' + this.contentPassKey;
        dataUrl = this.addDateToDataUrl(dataUrl)
        
        return this._http.get(dataUrl);
         //.subscribe(response => console.log(response));
    }
    
    
    
     // else try with curDataObjDictionary
     if(this.getCurDataObjTempDictForPostType(postType) != false && this.getCurDataObjTempDictForPostType(postType).data_url) {
        console.log('DATA SERVICE MEDIUM - LOADING FROM TEMP DICT');
        let dataObject = this.getCurDataObjTempDictForPostType(postType);   // dont set sharedGlobals.curDataObject, relation posts etc...
        
        let dataUrl = dataObject.data_url;
        dataUrl = dataUrl + '&tkn=' + this.contentPassKey;
        dataUrl = this.addDateToDataUrl(dataUrl)
        
        
        return this._http.get(dataUrl);
         //.subscribe(response => console.log(response));
     }
     
    
     // else default
     //console.log('DATA SERVICE BAD');
     //console.log('POST TYPE:');
     //console.log(postType);
     //console.log('SHARED POST TYPE:');
     //console.log(this.sharedGlobals.curDataObj.post_type);
     //console.log('SHARED URL:');
     //console.log(this.sharedGlobals.curDataObj.data_url);
     
     let dataUrlWrap1: string = "https://bma-event.net/bmademo/?json=1&count=100&post_type="
     let dataUrlWrap2: string = ""
     
     let dataUrl = dataUrlWrap1 + postType + dataUrlWrap2 
     dataUrl = dataUrl + '&tkn=' + this.contentPassKey
     dataUrl = this.addDateToDataUrl(dataUrl)
     
     return this._http.get(dataUrl);
         //.subscribe(response => console.log(response));
  }
  
  
  getPostsByUrl(dataUrl: string) {
     dataUrl = dataUrl + '&tkn=' + this.contentPassKey
     dataUrl = this.addDateToDataUrl(dataUrl)
     return this._http.get(dataUrl);
         //.subscribe(response => console.log(response));
  }  
  

  
  
  getMenus() {
     let dataUrl = "https://bma-event.net/bmademo/api/get_app_s88ojldJLDjksyusjSJLi_prefs/"
     dataUrl = this.addDateToDataUrl(dataUrl)

     return this._http.get(dataUrl);
         //.subscribe(response => console.log(response));
         
  }
  
  
  addObjectsToStorage(postObjects: any, key: string) {
    this.storage.set(key, JSON.stringify(postObjects));
  }
  
  
  addCurUserToStorage(user: string) {
    this.storage.set('curLoggedUser', user);
  }


  addPlayerIdToStorage(playerId: string) {
    try {
      this.storage.set('curPlayerId', playerId);
    } catch (error) {
      console.log(error)
    }
  }

  // call when setting userdata 
  updatePlayerIdsForUser(playerIds: string, user: string): Promise<string> {

    let arr:Array<string> = [];
    if(playerIds != "" && typeof playerIds === "string") {
      try {
        let arrPids = playerIds.split(",");
        for(let i=0; i<arrPids.length; ++i) {
          arr.push(arrPids[i]);
        }
      } catch (error) {
        console.log(error)
      }
    }


    //console.log("playerIds before adding current")
    //console.log(playerIds)

    const storageCall = this.storage.get('curPlayerId').then(val => {
      //console.log('curPlayerId1: ' + val)
      if(val != null && val != '' && !arr.includes(val)) {
            arr.push(val);
      } 
      // else arr.push("testingOnlyCommentOut")
      if(arr.length > 0) {
        //console.log(arr) // debug playerids
        playerIds = arr.toString()
      } else {
        playerIds = "";
      }
      return playerIds;
    }, rejected => {console.log(rejected); return ""})

    return storageCall;

  }

  
  
  addFavsToStorage(postObjects: any, key: string) {
    this.sharedGlobals.favsDict[key] = postObjects; // quick access
    this.sharedGlobals.favsSharedPreloaded = true;
    
    this.addObjectsToStorage(postObjects, key); // on app load
  }
  
  
  addRatedPostsToStorage(postObjects: any, key: string) {
    this.sharedGlobals.ratedPostsDict[key] = postObjects; // quick access
    this.sharedGlobals.ratedPostsSharedPreloaded = true;
    
    this.addObjectsToStorage(postObjects, key); // on app load
  }
  
  
  
  
  getLang(string: string) {
     if (this.sharedGlobals.langDict[string] && this.sharedGlobals.langDict[string][this.sharedGlobals.lang]) {
        return this.sharedGlobals.langDict[string][this.sharedGlobals.lang];
     }
        return string;
  }
  
  getLangCustom(string: string) {
     if (this.sharedGlobals.langDict[string] && this.sharedGlobals.langDict[string][this.sharedGlobals.lang]) {
        return this.sharedGlobals.langDict[string][this.sharedGlobals.lang];
     }
        return this.sharedGlobals[string];
  }
  
  addLangCode(string: string) {
    return (string + 'lang' + this.sharedGlobals.lang).trim();
  }
  
  removeLangCode(string: string) {
        return (string.replace('lang' + this.sharedGlobals.lang, '')).trim();
  }
  
  
  setCurDataObjTempDict(curDataObj: any) {
  
    if (curDataObj && curDataObj.post_type) {
        this.curDataObjDictionary[curDataObj.post_type] = curDataObj;
    }
    

    //console.log("CurDataObjDictionary:");
    //console.log(this.curDataObjDictionary);
  
  }
  
  getCurDataObjTempDictForPostType(postType: string) {
    

    if (this.curDataObjDictionary[postType]) {
        //console.log("CurDataObj For post type is:");
        //console.log(this.curDataObjDictionary[postType]);
        return this.curDataObjDictionary[postType];
    }
    console.log(postType);
    console.log("CurDataObj For post type is NULL");
    return false;
    
    
    console.log("Try getting from from URL path");
    // try with url string...
    return this.getCurDataObjTempDictFromCurrentUrlLocation();
    
    
  }
  
  
  
  getCurDataObjTempDictFromCurrentUrlLocation() {
  
    let postType = this.router.url.split('/').pop();
    console.log(postType + 'from url');
    
     if (this.curDataObjDictionary[postType]) {
        console.log("Found from url path");
        console.log(postType);
        return this.curDataObjDictionary[postType];
    }
    return false;
  
  }
  
  
  
  
  
  
  isNotLocked(postType: string) {
  
    let curDataObj = this.getCurDataObjTempDictForPostType(postType); 
    
    //console.log("CHECK IF LOCKED FOR CUR DATA OBJECT:");
    //console.log(curDataObj);
    if (this.sharedGlobals.curLoggedUser != '') { // user logged in
        //console.log('NOT LOCKED 1');
        return true;
    }
    else if (curDataObj.locked_content !== '1') { // content is not locked
        //console.log('NOT LOCKED 2');
        return true;
    }   
    //console.log('LOCKED');
    return false;
  
  }
  
  
  
  
  
  isProtected(curDataObj: any) {
    //!!!! PROBLEM!!! ne zaznaz cifre
    //console.log("CHECK IF PROTECTED FOR CUR DATA OBJECT:");
    //console.log(curDataObj);
    //console.log(curDataObj.pass_protected);
    if (parseInt(curDataObj.pass_protected) !== 1) { // content is not locked
        //console.log('NOT PROTECTED');
        return false;
    }   
  
  
    // compare passwords
    if (this.sharedGlobals.passkey_entered === this.sharedGlobals.passkey) { // content is not locked
        //console.log('PROTECTED && PASSWORD OK = VISIBLE');
        return false;
    }   
    
    
    //console.log('PROTECTED && PASSWORD NOT OK = HIDDEN');
    return true;
  
  }
  
  
  
  
  
  
  
  
  trackThisPage(pageName: string) {
  
    this.analytics.setCurrentScreen(pageName)
    this.analytics.logEvent("page_open", {content_type: "page_view", item_id: pageName})
  
  
  /** GA is deprecated
    this.ga.startTrackerWithId('UA-133764406-1')
       .then(() => {
            //console.log('Google analytics is ready now');
            this.ga.trackView(pageName);
       })
       .catch(e => console.log('Error starting GoogleAnalytics', e
  **/
  }
  
  
  trackRating(pageId: string, ratingNum: string) {

    if (ratingNum == '-1') {
        ratingNum = 'skip';
    }
   
    let rnm = 'rating' + '_' + ratingNum;
    let pid = 'p_' + pageId;

    this.analytics.logEvent('select_content', {
        content_type: rnm,
        content_id: pid
        })
  
        
  }

  
  
  shouldScheduleDate(incomingDate) {
    //incomingDate = item.custom_fields.event_start_date[0];
    let time15FromNow = new Date().getTime() + (15*60000);
    let incTime = new Date(incomingDate).getTime();
    
    //console.log('CHECKER NEW');
    //console.log('Time Now: ' + new Date() + ', 15mins on: ' + time15FromNow);
    //console.log('Event Time: ' + new Date(incomingDate) + ', ' + incTime);
    
    if(incTime > time15FromNow) {
        return true;
    }
    return false;
    
  }
  
  
  
  
  setPassingPostObject(item) {
    if (item.type) {
        item['post_type'] = item.type;
    }
    
    this.curPostObject = item;
  }
  
  getPassingPostObject() {
    return this.curPostObject;
  }
  


  imgError(error) {
    error.onerror = "";
    if(error.target && error.target.src) {
        error.target.src = this.sharedGlobals.errorImg;
    }
  }




  async presentAlertNotNative() {
    const alert = await this.alertCtrl.create({
      cssClass: 'ion-text-center',
      header: this.getLang('Available in Mobile App'),
      message: this.getLang('Download App through the AppStore or GooglePlay to test this functionality'),
      buttons: [
      {
        text: this.getLang('Close'),
        role: 'close',
        cssClass: 'secondary',
        handler: (blah) => {
        console.log('Close')
        },
      }
      ],
    });
    await alert.present();

    setTimeout(() => {
      if(typeof(alert) !== undefined) alert.dismiss();
    }, 5000);
    
    }


    async presentAlertWithMessage(title: string, message: string) {
      const alert = await this.alertCtrl.create({
        cssClass: 'ion-text-center',
        header: this.getLang(title),
        message: this.getLang(message),
        buttons: [
        {
          text: this.getLang('Close'),
          role: 'close',
          cssClass: 'secondary',
          handler: (blah) => {
          console.log('Close')
          },
        }
        ],
      });
      await alert.present();
  
      setTimeout(() => {
        if(typeof(alert) !== undefined) alert.dismiss();
      }, 3000);
      
      }


}



